'use client'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { debounce } from 'lodash-es'
import { toPairs } from 'ramda'
import { isMobile } from 'react-device-detect'
// import classNames from 'classnames'

import { addEventTag } from 'helpers/utilities'
// import { genWordLocationPath } from '../../helper'

// import HomeSearchInPc from "app/(new-pages)/components/HomeSearch/pc/index.pc";
import CommonSearchPc from 'app/(new-pages)/components/Search/pc/index.pc'
import StickySearch from './StickySearch.pc.client'

import { fetchSearchRemoteSuggestionService } from 'store/services/jobs/fetchSearchSuggestion'
// import { zipLocation } from '../../services'

import styles from '../../styles/index.pc.module.scss'
import { SearchLogo } from '../../images/icons-search'
import PopoverDownload from './PopoverDownload'
import { createSearchHistoryManager } from 'helpers/searchHistory'

const transObject = (params) => {
  const result = {}
  params.forEach((e, index) => {
    result[`query_histories[${index}]`] = e
  })
  return result
}

export const handleFilterSuggestionList = (suggestionList = []) => {
  return suggestionList.map((item) => {
    if (item?.length && typeof item === 'string') {
      return { value: item, label: item }
    }

    return {
      ...item,
      label: item?.value
    }
  })
}

const google_tags = ['hp_location_click', 'hp_search_focus', 'hp_search_click']

interface SearchInputProps {
  langKey: string
  lang: any
}

const SearchInput = (props: SearchInputProps) => {
  const isPC = !isMobile
  const { langKey } = props
  const lang = props?.lang || {}
  const remotePage = lang?.remotePage || {}
  const [query, setQuery] = React.useState('')
  const [suggestionList, setSuggestionList] = useState([])
  const { getSearchHistory, addSearchHistory, removeSearchHistory } = createSearchHistoryManager()
  const [selectQuery, setSelectQuery] = useState(null)
  const [isShow, setIsShow] = useState(false)
  const [isDownloadAppOpacity, setIsDownloadAppOpacity] = useState(false)
  const [isMouseEnter, setIsMouseEnter] = useState(false)
  const timer = useRef(null)
  const searchHistories = getSearchHistory()

  useEffect(() => {
    isTouchBottom()
    window.document.addEventListener('scroll', useFn)
    return () => {
      window.document.removeEventListener('scroll', useFn)
      clearTimeout(timer?.current)
    }
  }, [])

  const isTouchBottom = () => {
    if (isPC) {
      const scrollTopHeight = document.body.scrollTop || document.documentElement.scrollTop

      if (scrollTopHeight > 780) {
        setIsDownloadAppOpacity(true)
      } else {
        setIsDownloadAppOpacity(false)
      }

      if (scrollTopHeight > 150) {
        setIsShow(true)
        return
      }
    }

    setIsShow(false)
  }

  const throttle = (func, delay) => {
    let timer = null
    return function () {
      if (!timer) {
        timer = setTimeout(() => {
          func()
          timer = null
        }, delay)
      }
    }
  }

  const useFn = throttle(() => {
    isTouchBottom()
  }, 300)

  const onSearch = (value, option) => {
    const isEvent = !option
    const val = isEvent ? query : value
    if (option) {
      setSelectQuery(option)
    }
    if (val && val.trim()?.length) {
      addSearchHistory(val)
    }
    setQuery(val)
    addEventTag(google_tags[2])
    if (option) {
      pushJobPage({ value: val, type: option?.type })
    } else {
      pushJobPage({ value: val, type: selectQuery?.type })
    }
  }
  const handleQuery = (val) => {
    setSelectQuery(null)
    setQuery(val)
    handleSuggestionSearch(val)
  }

  const pushJobPage = async ({ value = '', type = '' }) => {
    const keyWords = value?.trim?.().replace(/\s+/g, ' ')
    const words = (keyWords || '').trim()
    const url = new URLSearchParams(toPairs({ query: words })).toString()
    const urlPath = '/' + langKey + `/remote-jobs-hiring/job-search/` + (url ? '?' + url : '')
    window.location.href = urlPath
  }

  const handleSuggestionSearch = useCallback(
    debounce(async (val) => {
      const valueLength = val?.length ?? 0
      if (valueLength < 1) {
        setSuggestionList(searchHistories as any)
      } else {
        const qs = transObject(searchHistories)
        fetchSearchRemoteSuggestionService({ size: 5, query: val, ...qs }).then((data) => {
          const items = data?.data?.data?.items || []
          const result = items?.length ? items : searchHistories
          setSuggestionList(result)
        })
      }
    }, 300),
    [searchHistories]
  )

  const handleClear = (value, type) => {
    if (type !== 'history') return
    let newSuggestionList = suggestionList.filter((item) => {
      if (item !== value?.data?.label) return item
    })
    // console.log("newSuggestionList", newSuggestionList);
    setSuggestionList(newSuggestionList)
    removeSearchHistory(value?.data?.label)
  }

  return (
    <>
      <div>
        <div>
          <CommonSearchPc
            visibleLocation={false}
            query={query}
            setQuery={handleQuery}
            onSearch={onSearch}
            onClear={handleClear}
            inputPlaceholder={remotePage?.searchByJobTitle}
            inputOptions={{
              companyGroupText: remotePage?.companyGroupText,
              jobTitleGroupText: remotePage?.jobTitleGroupText,
              historyGroupText: remotePage?.historyGroupText,
              popularJobsText: remotePage?.popularJobsText
            }}
            suggestionList={handleFilterSuggestionList(suggestionList)}
            inputSearchText={remotePage?.inputSearchText}
            onFocus={() => {
              addEventTag(google_tags[1])
              if (!query?.length) {
                setSuggestionList(searchHistories as any)
              }
            }}
          />

          <StickySearch
            langKey={langKey}
            isShow={false}
            isDownloadAppOpacity={isDownloadAppOpacity}
          />
        </div>
      </div>
      {isShow && (
        <div
          className={styles.searchAreaFix}
          style={{ paddingBottom: isMouseEnter ? '0' : '15px' }}
        >
          <div className={styles.box}>
            <SearchLogo className={styles.searchLogo} />
            <CommonSearchPc
              visibleLocation={false}
              inputOptions={{
                companyGroupText: remotePage?.companyGroupText,
                jobTitleGroupText: remotePage?.jobTitleGroupText,
                historyGroupText: remotePage?.historyGroupText,
                popularJobsText: remotePage?.popularJobsText
              }}
              query={query}
              setQuery={handleQuery}
              onSearch={onSearch}
              onClear={handleClear}
              inputPlaceholder={remotePage?.searchByJobTitle}
              suggestionList={handleFilterSuggestionList(suggestionList)}
              inputSearchText={remotePage?.inputSearchText}
              onFocus={() => {
                addEventTag(google_tags[1])
                if (!query?.length) {
                  setSuggestionList(searchHistories as any)
                }
              }}
            />

            <StickySearch
              lang={props?.lang}
              langKey={langKey}
              isShow={true}
              isDownloadAppOpacity={isDownloadAppOpacity}
              onMouseEnter={() => {
                setIsMouseEnter(true)
              }}
              onMouseLeave={() => {
                timer.current = setTimeout(() => {
                  setIsMouseEnter(false)
                }, 500)
              }}
            />
          </div>

          <PopoverDownload
            show={isMouseEnter}
            onMouseEnter={() => {
              clearTimeout(timer.current)
              setIsMouseEnter(true)
            }}
            onMouseLeave={() => {
              setIsMouseEnter(false)
            }}
            lang={props?.lang}
          />
        </div>
      )}
    </>
  )
}

export default SearchInput
